import actions from './actions';

const initState = {
  // Estadísticas de Ventas
  ventas: {
    data: null,
    loading: false,
    error: null,
  },
  
  // Estadísticas de Ingresos
  ingresos: {
    data: null,
    loading: false,
    error: null,
  },
  
  // Estadísticas de Egresos
  egresos: {
    data: null,
    loading: false,
    error: null,
  },
};

export default (state = initState, action) => {
  switch (action.type) {
    // ============ ESTADÍSTICAS DE VENTAS ============
    case actions.GET_ESTADISTICAS_VENTAS:
      return {
        ...state,
        ventas: {
          ...state.ventas,
          loading: true,
          error: null,
        },
      };
      
    case actions.GET_ESTADISTICAS_VENTAS_SUCCESS:
      return {
        ...state,
        ventas: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
      
    case actions.GET_ESTADISTICAS_VENTAS_ERROR:
      return {
        ...state,
        ventas: {
          ...state.ventas,
          loading: false,
          error: action.payload,
        },
      };
    
    // ============ ESTADÍSTICAS DE INGRESOS ============
    case actions.GET_ESTADISTICAS_INGRESOS:
      return {
        ...state,
        ingresos: {
          ...state.ingresos,
          loading: true,
          error: null,
        },
      };
      
    case actions.GET_ESTADISTICAS_INGRESOS_SUCCESS:
      return {
        ...state,
        ingresos: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
      
    case actions.GET_ESTADISTICAS_INGRESOS_ERROR:
      return {
        ...state,
        ingresos: {
          ...state.ingresos,
          loading: false,
          error: action.payload,
        },
      };
    
    // ============ ESTADÍSTICAS DE EGRESOS ============
    case actions.GET_ESTADISTICAS_EGRESOS:
      return {
        ...state,
        egresos: {
          ...state.egresos,
          loading: true,
          error: null,
        },
      };
      
    case actions.GET_ESTADISTICAS_EGRESOS_SUCCESS:
      return {
        ...state,
        egresos: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
      
    case actions.GET_ESTADISTICAS_EGRESOS_ERROR:
      return {
        ...state,
        egresos: {
          ...state.egresos,
          loading: false,
          error: action.payload,
        },
      };
    
    // ============ RESET ============
    case actions.RESET_ESTADISTICAS:
      return initState;
    
    default:
      return state;
  }
};
